import React from 'react';
import { Box, Typography } from '@mui/material';
import RomaneioFormEdit from '../components/romaneio/RomaneioFormEdit';

const RomaneioEditar: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <RomaneioFormEdit />
    </Box>
  );
};

export default RomaneioEditar;
